import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TranslateModule } from '@ngx-translate/core';
import { AlertComponent, AssignComponent, ChartsComponent, LanguageComponent, PaginationComponent, PhoneNumberComponent, SubTaskDetailComponent, SubTicketDetailComponent, ThreeStateCheckboxComponent } from 'app/components';

import { DateConverterPipe, EnumKeyPipe } from 'app/pipes';
import { HttpClientModule } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCardModule } from '@core/components/core-card/core-card.module';
import { SaveTicketComponent, TicketCommentComponent, TicketHistoryComponent, TicketListComponent } from 'app/components/ticket';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { StartProjectListComponent } from 'app/components/start-project/start-project-list/start-project-list.component';
import { StartProjectDetailComponent } from 'app/components/start-project/start-project-detail/start-project-detail.component';
import { StartProjectDetailListComponent } from 'app/components/start-project/start-project-detail-list/start-project-detail-list.component';
import { RouterModule } from '@angular/router';
import { CoreSidebarModule } from '@core/components';
import { ProjectHistoryComponent } from 'app/components/start-project/project-history/project-history.component';
import { ProjectDetailListComponent } from 'app/components/start-project/project-detail-list/project-detail-list.component';
import { TicketAssignedEmployeeComponent } from 'app/components/ticket/ticket-assigned-employee/ticket-assigned-employee.component';



@NgModule({
  declarations: [
    ThreeStateCheckboxComponent,
    AlertComponent,
    PaginationComponent,
    DateConverterPipe,
    PhoneNumberComponent,
    EnumKeyPipe,
    SaveTicketComponent,
    ChartsComponent,
    AssignComponent,
    LanguageComponent,
    SubTaskDetailComponent,
    TicketCommentComponent,
    TicketListComponent,
    TicketHistoryComponent,
    TicketAssignedEmployeeComponent,
    ProjectHistoryComponent,
    StartProjectListComponent,
    ProjectDetailListComponent,
    StartProjectDetailComponent,
    StartProjectDetailListComponent,
    SubTicketDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ContentHeaderModule,
    TranslateModule,
    CoreCommonModule,
    CoreSidebarModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    CoreCardModule,
    NgSelectModule,
    Ng2FlatpickrModule,
    SweetAlert2Module.forRoot(),
  ],
  providers: [
  ],
  exports: [
    SubTaskDetailComponent,
    ThreeStateCheckboxComponent,
    AlertComponent,
    PaginationComponent,
    DateConverterPipe,
    PhoneNumberComponent,
    EnumKeyPipe,
    AssignComponent,
    LanguageComponent,
    SaveTicketComponent,
    TicketCommentComponent,
    TicketListComponent,
    TicketHistoryComponent,
    StartProjectListComponent,
    ProjectDetailListComponent,
    StartProjectDetailComponent,
    StartProjectDetailListComponent,
    ChartsComponent,
    CommonModule,
    TranslateModule,
    CoreCommonModule,
    ContentHeaderModule,
    Ng2FlatpickrModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    CoreCardModule,
    SweetAlert2Module,
    SubTicketDetailComponent
  ]
})
export class SharedModule { }
